import Utils from './utils';
import * as keys from './keys';
import ProductConstants from 'constants/ProductConstants';
import utils from './utils';
import StorageKeys from 'constants/StorageKeys';



const initialDefaults = (formRef, data) => {
	let productData = data?.data?.BI.find((item) => item.risk === data?.data?.risk);
	let biResponse = productData.parsedResponse;
	let biRequest = productData.bi_request;
	let firstYearResponse = productData.firstYearResponse;
	let LumpsumBenefit = biRequest?.LumpsumBenefit?.toString()
	let frequency = biRequest.INPUT_MODE?.toString()
	let incomeBenefitPayOutFrequency = biRequest.IncomeBenefitPayoutFrequency
	let SameProposer = biRequest?.SameProposer
	let annualisedPremium = biRequest.PR_ANNPREM == 0 ? firstYearResponse?.MODAL_PREM : biRequest.PR_ANNPREM;
	let pt = biRequest.PR_PT
	let ppt = biRequest.PR_PPT
	let isExistingCustomer = biRequest?.IsExistingCustomer
	let isECSMandate = biRequest?.IsECSMandate

	let planOption = biRequest?.PlanOption
	let deathBenefitOption = biRequest?.DeathBenefitOption
	let incomeBenefitPayoutStartYear = biRequest?.IncomeBenefitPayoutStartYear
	let incomeDuration = biRequest?.IncomeDuration
	let subChannel = biRequest?.PR_SUBCHANNEL
	let prChannel = biRequest?.PR_CHANNEL
	let subChannelCode = localStorage.getItem(StorageKeys.SUB_CHANNEL_CODE)
	let planOptionList = []

	formRef.$('PT').value = { id: pt, label: pt };

	if (keys.enableSubChannelList.includes(subChannelCode)) {
		planOptionList.push({ label: "Lump Sum", id: 1, })
		planOptionList.push({ label: "Lump Sum Plus Income", id: 2 })
	}
	formRef.$("plan-option").set("extra", {
		...formRef.$("plan-option").extra,
		optionList: planOptionList
	});
	if (subChannel) {
		let subChannelValue = formRef.$("sub-channel")?.extra?.optionList?.find((item) => Number(item?.id) === Number(subChannel))
		formRef.$("sub-channel").set('value', subChannelValue || "");
	}
	if (Number(prChannel) === 5) {
		formRef.$("sub-channel").set('disabled', false);
	} else {
		formRef.$("sub-channel").set('disabled', true);
	}

	// if (Number(pt) === 100) {
	// 	formRef.$("plan-option").set("extra", {
	// 		...formRef.$("plan-option").extra,
	// 		optionList: [
	// 			{ label: "Lump Sum", id: 1, },
	// 			{ label: "Lump Sum Plus Income", id: 2, }
	// 		],
	// 	});
	// } else {
	// 	formRef.$("plan-option").set("extra", {
	// 		...formRef.$("plan-option").extra,
	// 		optionList: [
	// 			{ label: "Lump Sum", id: 1, },
	// 		],
	// 	});

	// }

	// Utils.getPremiumTermList(ppt,formRef)
	// Utils.getPolicyTermList(biRequest.LI_ENTRY_AGE, LumpsumBenefit, formRef)

	formRef.$('PPT').value = { id: ppt, label: ppt };
	let pptList = utils.getPPTList(Number(planOption))
	formRef.$("PPT").set("extra", {
		...formRef.$("PPT").extra,
		optionList: pptList,
	});
	if (incomeBenefitPayoutStartYear) {
		formRef.$('income-benefit-payout-start-year').set('value', { label: Number(incomeBenefitPayoutStartYear) - 1, id: incomeBenefitPayoutStartYear })
		let incomeStartYearList = utils.getIncomeStartYearList(Number(ppt), Number(planOption))
		formRef.$("income-benefit-payout-start-year").set("extra", {
			...formRef.$("income-benefit-payout-start-year").extra,
			optionList: incomeStartYearList,
		});

	}

	switch (Number(isExistingCustomer)) {
		case 1:
			formRef.$('is-existing-customer').set('value', { label: 'Yes', id: 1 })
			break;
		case 2:
			formRef.$('is-existing-customer').set('value', { label: 'No', id: 2 })
			break;

		default:
			break;
	}

	switch (Number(isECSMandate)) {
		case 1:
			formRef.$('ecs-mandate-auto-debit').set('value', { label: 'Yes', id: 1 })
			break;
		case 2:
			formRef.$('ecs-mandate-auto-debit').set('value', { label: 'No', id: 2 })
			break;

		default:
			break;
	}

	switch (Number(planOption)) {
		case 1:
			formRef.$('plan-option').set('value', { label: 'LumpSum', id: 1 })
			formRef.$('income-benefit-pay-out-frequency').set('disabled', true)
			formRef.$('income-benefit-payout-start-year').set('disabled', true)
			formRef.$('income-duration').set('disabled', true)
			formRef.$('PT').set('disabled', false)
			break;
		case 2:
			formRef.$('plan-option').set('value', { label: 'LumpSum Plus Income', id: 2 })
			formRef.$('income-benefit-pay-out-frequency').set('disabled', false)
			formRef.$('income-benefit-payout-start-year').set('disabled', false)
			formRef.$('income-duration').set('disabled', false)
			formRef.$('PT').set('disabled', true)
			formRef.$('PT').value = { id: 100, label: Number(incomeBenefitPayoutStartYear) + utils.getIncomDurationValue(incomeDuration) - 2 };
			break;
		default:
			break;
	}


	if (deathBenefitOption) {
		let deathbenList = utils.getDeathBenefitList(Number(planOption))
		formRef.$('death-benefit-option').set("extra", {
			...formRef.$('death-benefit-option').extra,
			optionList: deathbenList,
		});
	}
	switch (Number(deathBenefitOption)) {
		case 3:
			formRef.$('death-benefit-option').set('value', { label: 'Death Benefit Option 1', id: '3' })
			break;
		case 4:
			formRef.$('death-benefit-option').set('value', { label: 'Death Benefit Option 2', id: '4' })
			break;
		case 5:
			formRef.$('death-benefit-option').set('value', { label: 'Death Benefit Option 3', id: '5' })
			break;
		default:
			break;

	}

	switch (frequency) {

		case '1':
			formRef.$('payment-frequency').set('value', { label: 'Annual', id: '1' })
			break;
		case '2':
			formRef.$('payment-frequency').set('value', { label: 'Semi-Annual', id: '2' })
			break;
		case '3':
			formRef.$('payment-frequency').set('value', { label: 'Quarterly', id: '3' })
			break;
		case '4':
			formRef.$('payment-frequency').set('value', { label: 'Monthly', id: '4' })
			break;

		default:
			break;

	}

	switch (Number(incomeBenefitPayOutFrequency)) {

		case 24:
			formRef.$('income-benefit-pay-out-frequency').set('value', { label: 'Annual', id: '24' })
			break;
		case 25:
			formRef.$('income-benefit-pay-out-frequency').set('value', { label: 'Semi-Annual', id: '25' })
			break;
		case 26:
			formRef.$('income-benefit-pay-out-frequency').set('value', { label: 'Quarterly', id: '26' })
			break;
		case 27:
			formRef.$('income-benefit-pay-out-frequency').set('value', { label: 'Monthly', id: '27' })
			break;

		default:
			break;

	}

	if (incomeDuration) {
		let incomeDurationList = utils.getIncomeDurationList(Number(planOption))
		formRef.$('income-duration').set("extra", {
			...formRef.$('income-duration').extra,
			optionList: incomeDurationList,
		});
	}

	switch (Number(incomeDuration)) {
		case 28:
			formRef.$('income-duration').set('value', { label: '15', id: '28' })
			break;

		case 29:
			formRef.$('income-duration').set('value', { label: '20', id: '29' })
			break;
		case 30:
			formRef.$('income-duration').set('value', { label: '25', id: '30' })
			break;

		case 31:
			formRef.$('income-duration').set('value', { label: '30', id: '31' })
			break;

		default:
			break;
	}


	formRef.$('annualised-premium').set('value', annualisedPremium)

	// RIDER INITIAL VALUES

	if (biRequest.ADBRider) {
		formRef.$('ADB').set('value', biRequest.ADBRider !== '')
		if (biRequest.ADBRider) {
			formRef.$('ADB-dropdown').set('value', biRequest.ADBRider)
		}
	}
	if (biRequest.ATPDRider) {
		formRef.$('ATPDRider').set('value', biRequest.ATPDRider !== '')
		if (biRequest.ATPDRider) {
			formRef.$('ATPDRider-dropdown').set('value', biRequest.ATPDRider)
		}
	}

	if (biRequest.WaiverOfPremiumRider) {
		formRef.$('WaiverOfPremiumRider').set('value', biRequest.WaiverOfPremiumRider !== '')
	}

	if (biRequest.HospitalityCashBenefitRider) {
		formRef.$('HospitalityCashBenefitRider').set('value', biRequest.HospitalityCashBenefitRider !== '')
		if (biRequest.HospitalityCashBenefitRider) {
			formRef.$('HospitalityCashBenefitRider-dropdown').set('value', biRequest.HospitalityCashBenefitRider)
		}
	}

	if (biRequest.CriticalIllnessRider) {
		formRef.$('CriticalIllnessRider').set('value', biRequest.CriticalIllnessRider !== '')
		if (formRef.$('CriticalIllnessRider').value) {
			formRef.$('CriticalIllnessRider-dropdown').set('value', biRequest.CriticalIllnessRider)
		}
	}


	if (SameProposer) formRef.$('PayorWaiverBenefitRider').set('disabled', true)
	else formRef.$('PayorWaiverBenefitRider').set('disabled', false)

	if (biRequest.PayorWaiverBenefitRider) {

		formRef.$('PayorWaiverBenefitRider').set('value', biRequest.PayorWaiverBenefitRider !== '')

		if (formRef.$('PayorWaiverBenefitRider').value) {
			switch (biRequest.PWB) {
				case '1':
					formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
						id: '1',
						label: 'Option 1 (On Death)'
					})
					break;
				case '2':
					formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
						id: '2',
						label: 'Option 2 (CI or ATPD)'
					})
					break;
				case '3':
					formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
						id: '3',
						label: 'Option 3 (CI or ATPD or Death)'
					})
					break;
				default:
					break;
			}
		}
	}

}



export default initialDefaults